import { createGlobalStyle } from 'styled-components'
import colors from './colors'

const StyledGlobalStyle = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;0,700;0,900;1,400;1,700;1,900&family=Raleway:wght@300;400;500;600;700&display=swap');

  * { box-sizing: border-box; }
  a { text-decoration: none; }

  body {
    background-color: ${colors.blanc};
    font-family: 'Raleway', sans-serif;
    margin: 0;
    padding: 0;
    /* Réserve la hauteur du bandeau fixe (voir BannerFourrage) */
    padding-top: var(--pf-banner-h, 0px);
    -webkit-font-smoothing: antialiased;
  }

  ::-webkit-scrollbar { width: 6px; }
  ::-webkit-scrollbar-track { background: ${colors.beige}; }
  ::-webkit-scrollbar-thumb { background: ${colors.or}; border-radius: 3px; }
`

function GlobalStyle() {
  return <StyledGlobalStyle />
}

export default GlobalStyle
